import { createSlice } from "@reduxjs/toolkit";
import { quickTextTemplateActions } from "../actions/quickTextTemplateActions";

const initialState = {
  selectedTemplate: {
    id: "",
    title: "",
    description: "",
  },
  showModal: false,
  modalTitle: "",
  filters: [],
  isLoading: false,
  searchText: "",
  showConfirmModal: false,
  templateToDelete: null,
  shouldRefetch: false,
};

const quickTextTemplateSlice = createSlice({
  name: "quickTextTemplate",
  initialState,
  reducers: quickTextTemplateActions,
});

export const {
  openTemplateModal,
  setLoading,
  setTableFilters,
  closeTemplateModal,
  setSelectedTemplate,
  changeSearch,
  openConfirmModal,
  closeConfirmModal,
  refetchQuickTextTemplateList,
} = quickTextTemplateSlice.actions;

export default quickTextTemplateSlice.reducer;
